import React, { SVGAttributes } from "react";
import { styled } from "@mui/material/styles";
import {
  CollectionsIcon as CollectionsIconMui,
  MenuIcon,
} from "../../../../../../icons";
import { BSPBody2 } from "../../../BSPBody2";
import { Icon } from "../../styles";

export const Menu = styled("div")<{
  $isOpen?: boolean;
}>`
  position: absolute;
  bottom: 50px;
  left: -100px;
  display: flex;
  flex-direction: column;
  z-index: 1;
  padding: 20px;
  background-color: #555553;
  border: 1px solid #6e6e6b;
  border-radius: 16px;
  visibility: ${({ $isOpen }) => ($isOpen ? "visible" : "hidden")};
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transition: opacity 250ms ease, bottom 150ms ease;
  ${({ theme }) => theme.breakpoint.minWidth.large`
    left: -60px;
  `}
`;

export const Wrapper = styled("div")`
  position: relative;
  z-index: 1;
`;

export const OptionWrapper = styled(BSPBody2)`
  cursor: pointer;
  display: flex;
  align-items: center;
  color: white;
  font-weight: 500;
  > span {
    white-space: nowrap;
  }

  svg {
    margin-right: 5px;
  }

  & + & {
    margin-top: 12px;
  }
`;

export const MoreIcon = styled(MenuIcon)`
  ${Icon};
`;

export const CollectionsIcon = styled(CollectionsIconMui)`
  ${Icon};
  fill: white;
`;

export const BackgroundsIcon = styled((props: SVGAttributes<SVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_769_90322_camera)">
      <mask
        id="mask0_769_90322_camera"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" />
      </mask>
      <g mask="url(#mask0_769_90322_camera)">
        <path d="M3 9.65V7.525L7.525 3H9.65L3 9.65ZM3 4.75V3H4.75L3 4.75ZM16.175 6.425C16.0083 6.24167 15.8293 6.06233 15.638 5.887C15.446 5.71233 15.25 5.55833 15.05 5.425L17.475 3H19.6L16.175 6.425ZM5.5 14.975L7.425 13.05C7.54167 13.2333 7.66267 13.4 7.788 13.55C7.91267 13.7 8.05 13.8417 8.2 13.975C7.73333 14.0917 7.26233 14.2373 6.787 14.412C6.31233 14.5873 5.88333 14.775 5.5 14.975ZM17.5 10.05V10C17.5 9.68333 17.475 9.375 17.425 9.075C17.375 8.775 17.3 8.48333 17.2 8.2L21 4.4V6.55L17.5 10.05ZM10.9 4.6L12.525 3H14.65L13.05 4.6C12.8667 4.56667 12.6917 4.54167 12.525 4.525C12.3583 4.50833 12.1833 4.5 12 4.5C11.8167 4.5 11.6333 4.50833 11.45 4.525C11.2667 4.54167 11.0833 4.56667 10.9 4.6ZM3 14.625V12.5L6.6 8.9C6.56667 9.08333 6.54167 9.26667 6.525 9.45C6.50833 9.63333 6.5 9.81667 6.5 10C6.5 10.1833 6.50833 10.3583 6.525 10.525C6.54167 10.6917 6.56667 10.8583 6.6 11.025L3 14.625ZM20.725 16.7C20.5917 16.5 20.4377 16.3083 20.263 16.125C20.0877 15.9417 19.9 15.775 19.7 15.625L21 14.325V16.45L20.725 16.7ZM17.825 14.65C17.7083 14.6 17.5917 14.554 17.475 14.512C17.3583 14.4707 17.2417 14.4333 17.125 14.4C16.975 14.35 16.8293 14.3 16.688 14.25C16.546 14.2 16.4 14.1583 16.25 14.125L21 9.35V11.5L17.825 14.65ZM12 14C10.9 14 9.95833 13.6083 9.175 12.825C8.39167 12.0417 8 11.1 8 10C8 8.9 8.39167 7.95833 9.175 7.175C9.95833 6.39167 10.9 6 12 6C13.1 6 14.0417 6.39167 14.825 7.175C15.6083 7.95833 16 8.9 16 10C16 11.1 15.6083 12.0417 14.825 12.825C14.0417 13.6083 13.1 14 12 14ZM12 12C12.55 12 13.021 11.804 13.413 11.412C13.8043 11.0207 14 10.55 14 10C14 9.45 13.8043 8.979 13.413 8.587C13.021 8.19567 12.55 8 12 8C11.45 8 10.9793 8.19567 10.588 8.587C10.196 8.979 10 9.45 10 10C10 10.55 10.196 11.0207 10.588 11.412C10.9793 11.804 11.45 12 12 12ZM4 21V19.225C4 18.6583 4.14167 18.1333 4.425 17.65C4.70833 17.1667 5.1 16.8 5.6 16.55C6.45 16.1167 7.41267 15.75 8.488 15.45C9.56267 15.15 10.7333 15 12 15C13.2667 15 14.4373 15.15 15.512 15.45C16.5873 15.75 17.55 16.1167 18.4 16.55C18.9 16.8 19.2917 17.1667 19.575 17.65C19.8583 18.1333 20 18.6583 20 19.225V21H4ZM6.025 19H17.975C17.9417 18.85 17.8833 18.7207 17.8 18.612C17.7167 18.504 17.6083 18.4167 17.475 18.35C16.875 18.05 16.1127 17.75 15.188 17.45C14.2627 17.15 13.2 17 12 17C10.8 17 9.73733 17.15 8.812 17.45C7.88733 17.75 7.125 18.05 6.525 18.35C6.39167 18.4167 6.28333 18.5083 6.2 18.625C6.11667 18.7417 6.05833 18.8667 6.025 19Z" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_769_90322_camera">
        <rect width="24" height="24" />
      </clipPath>
    </defs>
  </svg>
))`
  width: 20px;
  height: 20px;
  fill: white;
`;
